<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        사이트 정보
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WMDS</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">사이트</a>
        </li>
      </ul>
    </div>
    <quick-setup @refresh="refresh" v-if="is_first" @count="x => this.$emit('count', x)"></quick-setup>
    <b-row v-else>
      <b-col lg="12" :xl="isLoadPolicy ? 8 : 12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              사이트 정보 <span v-if="!add && model.created_at">( 등록일 : {{model.created_at | sdate}})</span>
            </div>
            <div class="mb7">
              <span class="float-right" v-if="!add && model.last_visit">최근 점검일 : {{model.last_visit | utcsdate}}</span>
              <span class="float-right" v-else> - </span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="add" style="cursor:pointer">
              <label class="col-form-label" for="ph_use" v-b-tooltip.hover title="Start site registration and check">
                등록시 시작
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center" v-if="add" style="cursor:pointer">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login"  v-model="model.is_start" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" label-for="ph_use" v-b-tooltip.hover title="스캔 활성화 비활성화">
              <label class="col-form-label" for="ph_use">
                상태 <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="ph_use" id="Allow_login" v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" label-for="ph_use" v-b-tooltip.hover title="Toggle js click event trigger">
              <label class="col-form-label" for="ph_use">
                js 이벤트 <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="ph_use" id="Allow_login" v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" label-for="ph_use" v-b-tooltip.hover title="Set Login enable or disable">
              <label class="col-form-label" for="ph_use">
                로그인 사용 <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="ph_use" id="Allow_login" v-model="model.is_login" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-show="!lock">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_schedule_type" v-b-tooltip.hover title="지정할 정책을 확인하세요. 정책은 미리 생성되어야 합니다.">
                정책 <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-select v-model="model.policy_id" @change="change($event)" :disabled="lock" ref="policy">
                <option v-for="item in policy_list" :key="item.id" :value="item.id">{{item.description ? item.description : item.policy.description}}</option>
              </b-form-select>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username" v-b-tooltip.hover title="사이트를 구분하는 이름을 지정합니다.">
                이름 <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-input placeholder="Auto Fill when write FQDN input" type="text" id="ph_name" v-model="model.name" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-show="!add && lock">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" v-b-tooltip.hover title="지정할 정책을 확인하세요. 정책은 미리 생성되어야 합니다.">
                정책 <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              {{policy.description}}
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username" v-b-tooltip.hover title="사이트를 구분하는 이름을 지정합니다.">
                이름 <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-input placeholder="Auto Fill when write FQDN input" type="text" id="ph_name" v-model="model.name" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <b-form-group>
                <label class="col-form-label">
                  FQDN : ex) www.f1security.co.kr : www(host) + f1security.co.kr(domain)
                </label>
                <b-input-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> FQDN </b-input-group-text></b-input-group-prepend>
                  <b-form-input class="text-center border form-control" type="text" ref="fqdn" id="ph_fqdn" placeholder="FQDN (ex : www.company.com)" v-model="model.fqdn" :plaintext="lock" @change="check_fqdn"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <label
                style="cursor:pointer"
                @click="msg = '확인할 URL 또는 확인할 기본 페이지 또는 확인할 페이지의 URL입니다'; modal_explain = true"
              >
                점검 시작 URL (최대 10)
                <i class="fa fa-question-circle"></i>
              </label>
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend><b-input-group-text> 시작 URL </b-input-group-text></b-input-group-prepend>
                  <b-form-input class="text-center border form-control" id="ph_seed" v-model="v.seed" type="url" placeholder="Full URL, ex) https://f1security.co.kr" @keyup.native.enter="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)">추가</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(seed, index) in model.config.seeds" :key="index"><i class="fa fa-times" @click="remove_seed(seed)" v-show="!lock"></i> {{seed}}</b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label
                  style="cursor:pointer"
                  @click="msg = '점검 주기를 설정하고, 사이트에 접속하는 사람이 적은 시간대에 적어도 하루에 한 번은 확인하는 것을 권장합니다.'; modal_explain = true"
                >
                  일정 확인
                  <i
                  style="cursor:pointer"
                  class="fa fa-question-circle"
                  ></i>
                </label>
                <small>최대 :{{max_schedule}}</small>
                <br>
                * <b-badge variant="warning">공지</b-badge>
                : 사이트 가용성을 위해 하루 최대 확인 수를 제한하십시오.
                <hr>
                <b-input-group>
                  <b-form-select ref="schedule" id="ph_schedule" v-model="s.h" :options="s.h_opt" :disabled="lock" @change="schedule($event, 'h')"></b-form-select>
                  <b-form-select v-model="s.m" :options="s.m_opt" :disabled="lock" @change="schedule($event, 'm')"></b-form-select>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_schedule" :disabled="lock || (model.schedule.length >= max_schedule)">추가</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <!-- // TODO : 나중에 크론 문법 아는 사람들을 위해 제공 예정 -->
              <!-- <b-form-group>
                <b-input-group>
                    <b-input-group-prepend><b-input-group-text>Custom Schedule(Use Cron Grammar) </b-input-group-text></b-input-group-prepend>
                    <b-form-input id="ph_schedule_custom" v-model="s.schedule_custom" type="text" placeholder="ex) 0 0 * * * *" @keyup.native.enter="add_schedule_custom" :disabled="lock || (model.schedule.length >= max_schedule)"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_schedule_custom" :disabled="lock || (model.schedule.length >= max_schedule)">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(schedule, index) in model.schedule" :key="index">
                    <i class="fa fa-times" @click="remove_schedule(schedule)" v-if="!lock"></i>
                    ({{ schedule }}) {{ schedule | cron_filter }}
                  </b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <strong>추가 정보</strong>
          <b-row class="mt-3">
            <b-col md="6">
              <b-form-group>
                <label
                  style="cursor:pointer"
                  for="ph_sub_domain"
                  @click="msg = '동일한 사이트 내에 하위 도메인이 있는 경우 등록 ex) admin.f1security.co.kr'; modal_explain = true"
                >
                  하위 도메인
                  <i class="fa fa-question-circle"></i>
                </label>
                <b-input-group>
                  <b-form-input id="ph_sub_domain" v-model="v.sub" type="text" ref="sub_domains" placeholder="도메인" @keyup.native.enter="add_sub" :disabled="lock || (model.config.subs.length >= 100)"></b-form-input>
                  <b-button variant="primary" @click="add_sub" :disabled="lock || (model.config.subs.length >= 100)">추가</b-button>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(sub, index) in model.config.subs" :key="index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_sub(sub)"></i> {{sub}}</b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label
                  style="cursor:pointer"
                  for="ph_prevent"
                  @click="msg = '예외를 처리해야 하는 경로를 지정합니다. ex)/admin/download'; modal_explain = true">
                  예외 경로
                  <i class="fa fa-question-circle"></i>
                </label>
                <b-input-group>
                  <b-form-input id="ph_prevent" v-model="v.prevent" ref="prevent" type="text" placeholder="예외 경로" @keyup.native.enter="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)">추가</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(prevent, index) in model.config.prevents" :key="index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_prevent(prevent)"></i> {{prevent}}</b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group>
                <label
                  style="cursor:pointer"
                  for="regex"
                  @click="msg = '정규표현식으로 예외처리할 단어를 입력(일치 가능) ex) (편집 | 삭제)'; modal_explain = true"
                >
                  정규식 예외 처리
                  <i class="fa fa-question-circle"></i>
                </label>
                <b-input-group>
                  <b-form-input id="regex" v-model="model.regex" type="text" ref="regex" placeholder="정규식 포맷 사용" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="lock">
            <template v-if="model.is_del">
              <!-- <b-button size="sm" variant="success" @click="revive"> 되돌리기 </b-button> -->
            </template>
            <template v-else>
              <b-button size="sm" variant="warning" @click="edit"> 편집 </b-button>
              <b-button size="sm" variant="danger" @click="del_confirm = true"> 삭제 </b-button>
            </template>
          </template>
          <template v-else>
            <b-button size="sm" variant="add" @click="() => model.id ? save() : modal_charge_agree = true"> 저장 </b-button>
            <b-button size="sm" variant="secondary" @click="cancel"> 취소 </b-button>
          </template>
          <b-button size="sm" class="float-right text-white" variant="primary" @click="list"> 목록 </b-button>
        </b-card>
      </b-col>
      <!-- policy start -->
      <b-col lg="12" xl="4" v-if="isLoadPolicy">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              정책
            </div>
            <div class="mb7">
              <small class="float-right">읽기 전용 정보</small>
            </div>
          </div>
          <hr>
          <b-row class="text-center">
            <b-col md="12">
              <span block class="h5">{{ isLoadPolicy ?  policy.description : '-'}}</span>
              <hr>
              <small>
                이 페이지는 정책 정보만 표시되며 정책 편집 페이지에서 변경할 수 있습니다.
              </small>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <b-form-group class="text-center" v-b-tooltip.hover :title="`첫 페이지에서 다음 페이지로 링크를 이동(경로)하여 확인할지 여부를 입력합니다. 첫 페이지에서 다음 페이지로 링크를 이동(경로)하여 확인할지 여부를 입력합니다. 1-100 범위 내에서 지정할 수 있습니다`">
                  <b-input-group-prepend><b-input-group-text> 최대 경로 깊이 &nbsp;<i style="cursor:pointer" class="fa fa-question-circle"></i></b-input-group-text></b-input-group-prepend>
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_depth" :min="1" :max="100" v-model="policy.depth" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                class="text-center"
                v-b-tooltip.hover :title="`
                  페이지 내에서 탐색하려면 최대 하위 링크를 입력합니다.
                  초과 링크는 않으며 일반적으로 한 페이지에 너무 많은 링크가 있는 경우, 다른 페이지로 이동하기 전에 최대 탐색 페이지에 도달하여 균형 있게 점검되지 못할 수 있습니다.
                  1-1,000 범위 내에서 지정할 수 있습니다`"
              >
                <b-input-group-prepend><b-input-group-text> 하위 페이지 링크 &nbsp;<i style="cursor:pointer" class="fa fa-question-circle"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1" :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                class="text-center"
                v-b-tooltip.hover :title="`
                  검사 사이트에서 확인할 총 페이지 수입니다.
                  입력한 번호에 도달하면 검사를 종료합니다.
                  해당 설정은 1 부터 라이선스 제한 범위 내에서 자유롭게 지정할 수 있습니다.`"
              >
                <b-input-group-prepend><b-input-group-text> 최대 탐색 페이지 &nbsp;<i style="cursor:pointer" class="fa fa-question-circle"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input :disabled="true" class="text-center border" type="number" id="ph_limit" :min="10" :max="50000" v-model="policy.limit" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                class="text-center"
                v-b-tooltip.hover :title="`
                  페이지 로딩 대기 시간은 1~30 범위 내에서 지정할 수 있습니다`"
              >
                <b-input-group-prepend><b-input-group-text> 시간 초과(초) &nbsp;<i style="cursor:pointer" class="fa fa-question-circle"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input :disabled="true" class="text-center border" type="number" id="ph_timeout" :min="1" :max="30" v-model="policy.timeout" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group 
                class="text-center"
                v-b-tooltip.hover :title="`새 페이지로 이동하기 전에 기다려야 할 시간입니다. 1 ~ 10,000 범위 내에서 지정할 수 있습니다`"
              >
                <b-input-group-prepend><b-input-group-text> 점검 속도(밀리초) &nbsp;<i style="cursor:pointer" class="fa fa-question-circle"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="0" :max="10000" v-model="policy.delay" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <template>
            <b-button block size="sm" variant="add" @click="policy_manage"> 관리 </b-button>
          </template>
        </b-card>
        <!-- result start -->
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              <div class="title mr-auto mb7">
                <span v-if="result.page_count > 0">최신 검사 결과 확인</span>
                <span v-else>최신 검사 결과를 가지고 있지않습니다.</span>
              </div>
            </div>
          </div>
          <hr>
          <template>
            <b-button :disabled="!(result.page_count > 0)" block size="sm" variant="warning" @click="confirm_result = true"> 확인 </b-button>
          </template>
        </b-card>
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              <span>로그인 확인이 유효한지 여부를 표시합니다.</span>
            </div>
          </div>
          <hr>
            <template>
              <b-button :disabled="!is_using_login" block size="sm" :variant="is_using_login ? 'add' : 'secondary'"> {{ is_using_login ? '가능' : '불가능' }} </b-button>
            </template>
          </b-card>
      </b-col>
    </b-row>
    <!-- delete modal -->
    <b-modal title="등록된 사이트 삭제"  class="modal-danger" v-model="del_confirm" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="outline-danger" ok-title="확인" cancel-variant="outline-dark" cancel-title="취소">
      <p> 확인을 위해 등록된 사이트 삭제 </p>
      <p>
        삭제될 경우 악성코드의 유포 위치 및 정지 여부를 확인할 수 없습니다.
      </p>
      <p> <b> * 사이트 이름 확인 </b> </p>
      <p> 사이트 이름 삭제 : {{model.name}}  </p>
      <b-form-input v-model="del_nickname" placeholder="등록 취소하려는 서버 이름 입력"></b-form-input>
    </b-modal>
    <!-- result modal -->
    <b-modal size="xl" title="사이트 결과"  class="modal-primary" v-model="confirm_result" hide-footer @ok="confirm_result = false" ok-variant="outline-primary">
      <result :result_id="result.id" :site="model"></result>
    </b-modal>
    <!-- modal -->
    <b-modal size="xs" title="정보" v-model="modal_explain" hide-footer ok-variant="add">
      {{msg}}
    </b-modal>
    <b-modal v-model="modal_charge_agree" title="모든 에이전트 통제" @ok="charge_agree" no-close-on-backdrop header-bg-variant="warning">
      <h5>최초의 사이트가 등록 및 스캔이 되면 점검이 시작됩니다.</h5>
      <hr>
      <a target="_blank" :href="redir" class="card-link">
        <span class="text-dark">더보기</span>
        <i class="fa fa-share"></i>
        {{redir}}
      </a>
      <hr>
      <h6> <b>동의하십니까?</b></h6>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>